import { useTranslation } from 'react-i18next';

export const useErrorMessageResolver = () => {
  const { t } = useTranslation('validation');

  const resolveErrorMessage = (message?: string | { key: string; value: number }) => {
    if (!message) {
      return '';
    }

    if (typeof message === 'object') {
      return t(message.key, { count: message.value });
    }

    return t(message);
  };

  return resolveErrorMessage;
};
